import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=ff846874&scoped=true"
import script from "./orders-list.vue?vue&type=script&lang=js"
export * from "./orders-list.vue?vue&type=script&lang=js"
import style0 from "./orders-list.vue?vue&type=style&index=0&id=ff846874&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff846874",
  null
  
)

export default component.exports